<template>
  <div
    class="global__account-warning d-flex justify-space-between align-center"
    :class="{
      accountWarningMargin: isCart && isDrawerVisible,
      'reactivate-account': isAccountReactivation,
    }"
    :style="{
      background: currentTypeObject.color,
      border: !isAccountReactivation
        ? currentTypeObject.color + ' !important'
        : '',
    }"
    v-if="canBeShown"
  >
    <div
      class="d-flex align-center pr-4 global__account-warning--text-container"
      style="flex: 1 1 100%; min-width: 0"
    >
      <div class="d-flex mr-2" v-if="shouldShowIcon">
        <simple-svg :src="currentIcon" />
      </div>
      <v-icon v-else :color="currentTypeObject.icon.color" class="mr-2">
        {{ currentTypeObject.icon.code }}
      </v-icon>
      <warning-message
        :planStatus="getPlanStatus"
        :trialDays="trialDays"
        :userAlertError="userAlertError"
      />
    </div>
    <template v-if="!isTextEllipsis">
      <action-button
        :planStatus="getPlanStatus"
        :isAccountReactivation="isAccountReactivation"
      />
    </template>
    <template v-else>
      <div class="chevron-container d-flex justify-start">
        <v-icon color="primary" @click="handleOpenMoreDetails"
          >mdi-chevron-down
        </v-icon>
      </div>
    </template>
    <div
      v-show="openMoreDetails"
      class="global__warning--modal"
      v-click-outside="hideMoreDetails"
      :class="{
        darkmodeBackground: $vuetify.theme.dark,
      }"
    >
      <div class="d-flex justify-center">
        <div class="warning-modal__dialog--top-line"></div>
      </div>
      <v-row class="px-4 pt-3 pb-4" no-gutters>
        <v-col cols="12" class="mb-6">
          <warning-message
            :planStatus="getPlanStatus"
            :trialDays="trialDays"
            :userAlertError="userAlertError"
          />
        </v-col>
        <v-col cols="12" class="d-flex justify-center align-end">
          <action-button
            :planStatus="getPlanStatus"
            :isAccountReactivation="isAccountReactivation"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import i18n from '@/translations/lang.js'
import ClickOutside from 'vue-click-outside'
import { mapState } from 'vuex'
import ActionButton from './ActionButton.vue'
import WarningMessage from './WarningMessage.vue'
export default {
  name: 'AccountWarning',
  components: {
    ActionButton,
    WarningMessage,
  },
  data: () => ({
    currentType: 'warning',
    openMoreDetails: false,
    isTextEllipsis: false,
    isAccountReactivation: false,
    isDrawerVisible: true,
    typeObjects: {
      info: {
        icon: {
          code: 'mdi-information-outline',
          color: '#1E2977',
        },
        color: '#A0ACFF',
      },
      warning: {
        icon: {
          code: 'mdi-alert-circle',
          color: '#FF8F00',
        },
        color: '#FFECB3',
      },
    },
    icons: {
      reactivate: require('@/assets/snackbar/icons/info-solid.svg'),
    },
    currentLanguage: '',
  }),
  mounted() {
    this.checkActivation()
    this.updateLanguage()
    this.$root.$on('changeLanguage', this.updateLanguage)
    if (this.planInfo.subscription) {
      this.initWarning()
    }
    this.$root.$on('checkWarningTextSize', () => this.checkIfIsTextEllipsis())
    window.onresize = () => {
      this.checkIfIsTextEllipsis()
    }
    const drawerVisibleItem = localStorage.getItem('drawerVisible')
    this.isDrawerVisible = drawerVisibleItem === 'true'
    this.$root.$on('onDrawerChange', (visible) => {
      this.isDrawerVisible = visible
    })
  },
  beforeDestroy() {
    this.$root.$off('changeLanguage', this.updateLanguage)
    this.$root.$off('onDrawerChange')
  },
  directives: {
    ClickOutside,
  },
  watch: {
    planInfo() {
      this.checkActivation()
      this.initWarning()
    },
  },
  methods: {
    checkActivation() {
      const hasSubscriptionProp =
        this.planInfo?.hasOwnProperty('subscription') &&
        this.planInfo.subscription !== null

      this.isAccountReactivation = !hasSubscriptionProp
    },
    updateLanguage() {
      this.currentLanguage = this.$i18next.language
    },
    hideMoreDetails() {
      const element = document.querySelector('.global__warning--modal')
      if (element.getClientRects().length) {
        this.openMoreDetails = false
      }
    },
    initWarning() {
      if (this.planInfo.subscription?.status === 'trialing') {
        this.currentType = 'info'
      } else {
        this.currentType = 'warning'
      }
      setTimeout(() => {
        this.checkIfIsTextEllipsis()
      }, 0)
    },
    handleOpenMoreDetails() {
      setTimeout(() => {
        this.openMoreDetails = true
      }, 100)
    },
    isElementTooLong(e) {
      return e.clientWidth < e.scrollWidth
    },
    checkIfIsTextEllipsis() {
      const element = document.querySelector(
        '.global__account-warning--small-text'
      )
      if (element) {
        this.isTextEllipsis = this.isElementTooLong(element)
      } else {
        this.isTextEllipsis = false
      }
    },
  },
  computed: {
    ...mapState('user', {
      planInfo: 'userPlanInfo',
    }),
    ...mapState('dashboard', {
      isCardsLoaded: (state) => state.warnings.isCardsLoaded,
    }),
    getPlanStatus() {
      return this.planInfo.subscription?.status
    },
    isCart() {
      return this.$route.name === 'Cart'
    },
    canBeShown() {
      if (
        this.planInfo?.subscription?.status !== 'active' ||
        (!this.planInfo?.subscription && this.planInfo?.hasOwnProperty('subscription'))
      ) {
        return true
      }
      return false
    },
    trafficLimitReached() {
      return this.planInfo.limit.traffic > this.planInfo.limit.traffic_plan
    },
    currentTypeObject() {
      return this.typeObjects[this.currentType]
    },
    trialDays() {
      const timeDifference =
        new Date(this.planInfo.subscription?.trial_end * 1000).getTime() -
        new Date().getTime()
      const daysDifference = (timeDifference / (1000 * 3600 * 24)).toFixed(0)
      return Number(daysDifference)
    },
    userAlertError() {
      if (this.planInfo && this.currentLanguage) {
        if (this.isAccountReactivation) {
          return false
        } else if (
          this.planInfo.type_payment === 'boleto' &&
          this.planInfo.subscription.status === 'unpaid'
        ) {
          return i18n.t('message.navDrawer.userWarnings.paymentProblemTicket')
        } else {
          return i18n.t('message.navDrawer.userWarnings.paymentProblem')
        }
      }
      return false
    },
    shouldShowIcon() {
      return this.isAccountReactivation
    },
    currentIcon() {
      if (this.isAccountReactivation) return this.icons.reactivate
      return null
    },
  },
}
</script>
<style scoped>
.darkmodeBackground {
  background: var(--v-neutral-darken2) !important;
}
.fixed {
  position: fixed !important;
}
.global__account-warning {
  padding: 11px 24px;
}
.chevron-container {
  min-width: 170px;
}
@media (max-width: 1170px) {
  .chevron-container {
    min-width: 62px;
  }
}
.global__warning--modal {
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  background: white;
  width: 100%;
  z-index: 3;
}
.global__warning--modal > .v-card {
  height: 100%;
}
.global__account-warning .row .col:not(.global__warning--modal *) {
  word-break: break-all;
  hyphens: manual;
}
.warning-modal__dialog--top-line {
  width: 46px;
  margin: 10px 0px;
  height: 4px;
  background: #c2c6e7;
}
.reactivate-account .global__account-warning--text-container {
  flex: 1 1 70% !important;
}
.theme--dark .reactivate-account {
  border: 1px solid var(--brand-90, #0c1c8d) !important;
  background: var(--neutral-100-white, #171924) !important;
}
.theme--light .reactivate-account {
  border: 1px solid var(--brand-90, #d0d6fb) !important;
  background: var(--neutral-100-white, #fff) !important;
}
</style>
<style>
.global__account-warning
  > .global__account-warning--text-container
  > .global__account-warning--small-text {
  font-size: 13px;
  white-space: wrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: black !important;
}
@media (max-width: 1365px) {
  .global__account-warning
    > .global__account-warning--text-container
    > .global__account-warning--small-text {
    white-space: nowrap;
  }
  .global__account-warning {
    background: rgb(160, 172, 255);
    position: absolute;
    width: 100%;
    z-index: 2;
    bottom: 0px;
  }
}
.card-warnings__card-container--text {
  display: inline !important;
}
.global__account-warning
  .global__warning--modal
  .card-warnings__card-container {
  position: absolute;
  bottom: 23px;
}
.accountWarningMargin {
  margin-left: 206px;
  width: calc(100% - 206px);
}
</style>
